<script setup>
import { onMounted, ref } from 'vue'
import { useUtils } from 'src/composables/useUtils'

const { isVisible } = useUtils()
const yt = ref()
const disablePlay = ref(false)
const disableStop = ref(true)
const checkYtAutoPlay = async () => {
  const elements = document.getElementsByClassName('video--container')
  let element
  if (elements && elements[0]) {
    element = elements[0]
    const visible = isVisible(element)
    if (visible) {
      if (disablePlay.value) {
        return
      }
      disablePlay.value = true
      disableStop.value = false
      setTimeout(async () => {
        try {
          yt.value.play()
        } catch (e) {
          console.log('PLAY FAILED', e)
        }
      }, 200)
    } else {
      if (disableStop.value) {
        return
      }
      disablePlay.value = false
      disableStop.value = true
      yt.value.pause()
    }
  }
}

onMounted(() => {
  window.addEventListener('scroll', checkYtAutoPlay)
})
</script>

<template lang="pug">
.video--container
  #outer
    video(controls muted ref='yt' src='~assets/video/b2cvideo.mp4' type='video/mov' playsinline).video
  //.benefits--controls
  //  .benefits--play
  //    svg(width='50' height='51' viewBox='0 0 50 51' fill='none' xmlns='http://www.w3.org/2000/svg')
  //      g(clip-path='url(#clip0_7020_11832)')
  //        path(d='M25 48.0361C37.7025 48.0361 48 37.7387 48 25.0361C48 12.3336 37.7025 2.03613 25 2.03613C12.2975 2.03613 2 12.3336 2 25.0361C2 37.7387 12.2975 48.0361 25 48.0361Z' stroke='white' stroke-width='3' stroke-linejoin='round')
  //        path(d='M19 37.0361V13.0361L37 25.0361L19 37.0361Z' stroke='white' stroke-width='3' stroke-linejoin='round')
  //      defs
  //        clipPath#clip0_7020_11832
  //          rect(width='50' height='50' fill='white' transform='translate(0 0.0361328)')
  //  .benefits--name
  //    div Atilla Färber, CEO
  //    div Raumpionier
</template>

<style lang="sass">
#outer
  border-radius: 10px
  @media screen and (min-width: 600px)
    overflow: hidden
.video
  border-radius: inherit
.video--container
  width: 100%
  position: relative
  border-radius: 10px
  .video
    height: 100%
    //clip-path: inset(3px 3px)
    &:focus
      outline: none !important
    @media screen and (min-width: 600px)
      width: 100%
    @media screen and (max-width: 600px)
      border-radius: 0px !important
      width: calc(100vw + 15px)
      margin-left: -30px
      margin-bottom: -35px
  .benefits--controls
    position: absolute
    @media screen and (min-width: 600px)
      left: 56px
      bottom: 44px
    @media screen and (max-width: 600px)
      left: 38px
      bottom: 27px
    .benefits--play
      cursor: pointer
      @media screen and (min-width: 600px)
        margin-bottom: 20px
      @media screen and (max-width: 600px)
    .benefits--name
      font-weight: 500
      line-height: 130%
      color: #FFFFFF
      @media screen and (min-width: 600px)
        font-size: 34px
      @media screen and (max-width: 600px)
        font-size: 24px
</style>
